import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lightspeed/flame/Button';
import { Divider } from '@lightspeed/flame/Divider';

const Header = ({ dirty, isSaving }) => (
  <Fragment>
    <div className="cr-flex cr-justify-between cr-items-center cr-width-full cr-p-2 ">
      <Button variant="secondary" fill disabled={!dirty} loading={isSaving} type="submit">
        Save Changes
      </Button>
    </div>
    <Divider />
  </Fragment>
);

Header.propTypes = {
  dirty: PropTypes.bool,
  isSaving: PropTypes.bool,
};

Header.defaultProps = {
  dirty: false,
  isSaving: false,
};

export default Header;
